module.exports = __webpack_public_path__ + "img/estatus_regular.76db99bd.png";